import { ProductDetailPageContainer } from './ProductDetailPageContainer';

export default ProductDetailPageContainer;
